
import React from 'react'
import { SvgIconProps } from './Home'

const SvgFilterIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "24"}
    height={height ?? "24"}
    fill="none"
    viewBox={`0 0 ${width ?? '24'} ${height ?? '24'}`}
  >
    <path
      fill={fill ?? "#353535"}
      d="M19.237 11.22H17.67c-.33-1.18-1.381-2.044-2.619-2.044-1.237 0-2.288.885-2.639 2.044h-7.65A.77.77 0 004 12c0 .422.33.78.763.78h7.65c.33 1.18 1.38 2.045 2.618 2.045 1.237 0 2.289-.865 2.618-2.045h1.567a.77.77 0 00.763-.78.74.74 0 00-.742-.78zm-4.185 2.045c-.66 0-1.238-.548-1.238-1.265 0-.716.537-1.264 1.238-1.264.7 0 1.237.547 1.237 1.264s-.578 1.265-1.238 1.265zM4.763 6.604h1.629c.33 1.18 1.381 2.045 2.618 2.045 1.237 0 2.289-.864 2.619-2.045h7.608a.77.77 0 00.763-.78c0-.442-.33-.78-.763-.78H11.63C11.299 3.865 10.247 3 9.01 3c-1.237 0-2.288.864-2.618 2.045h-1.63a.77.77 0 00-.762.78c0 .442.33.78.763.78zM9.01 4.56c.66 0 1.237.548 1.237 1.264 0 .717-.536 1.265-1.237 1.265-.7 0-1.237-.59-1.237-1.265 0-.674.578-1.264 1.237-1.264zM19.237 17.396H11.63c-.33-1.18-1.382-2.044-2.619-2.044-1.237 0-2.288.864-2.618 2.044h-1.63a.77.77 0 00-.762.78c0 .443.33.78.763.78h1.629C6.722 20.136 7.773 21 9.01 21c1.237 0 2.289-.864 2.619-2.044h7.608a.77.77 0 00.763-.78c0-.443-.33-.78-.763-.78zM9.01 19.441c-.66 0-1.237-.549-1.237-1.265 0-.717.536-1.265 1.237-1.265.701 0 1.237.548 1.237 1.265 0 .716-.577 1.265-1.237 1.265z"
    ></path>
  </svg>
)

export default SvgFilterIcon